import script from "./HotspotPolygonEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./HotspotPolygonEditor.vue?vue&type=script&setup=true&lang=js"

import "./HotspotPolygonEditor.vue?vue&type=style&index=0&id=ad2c0d02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad2c0d02"]])

export default __exports__